/* eslint-disable max-len */
import { ReactElement } from 'react';
import './MeasureFieldLabel.css';

interface MeasureFieldLabelProps {
  displayName: string;
  isRequired: boolean;
  field: string;
  classes?: string;
  disabled?: boolean;
}

const MeasureFieldLabel = ({
  displayName,
  isRequired,
  field,
  classes,
  disabled,
}: MeasureFieldLabelProps): ReactElement => {
  const disabledClass = disabled ? 'disabled-label' : '';

  return displayName ? (
    <label
      className={
        classes
          ? `${classes} field-label ${disabledClass}`
          : `field-label ${disabledClass}`
      }
      data-testid="measure-field-label"
      htmlFor={field}
    >
      {isRequired && <span className="required-asterisk">* </span>}
      {displayName}
    </label>
  ) : (
    <></>
  );
};

export default MeasureFieldLabel;
